import {
  ArrowRightDoubleIcon,
  ArrowLeftDoubleIcon,
  PlayIcon
} from '@hugeicons/react'
import _ from 'lodash'

import { Button } from '@/shared/ui/Button'
import { LevelPlay } from '@/shared/ui/LevelPlay'

import { DigitalProductJourneyLevelPlayChallengeFooterIntroButton } from './IntroButton'
import { DigitalProductJourneyLevelPlayChallengeFooterRightAnswerAlert } from './RightAnswerAlert'
import { DigitalProductJourneyLevelPlayChallengeFooterWrongAnswerAlert } from './WrongAnswerAlert'
import { useLevelContext } from '../../../context'

export const DigitalProductJourneyLevelPlayChallengeFooter = ({
  id,
  activity = {},
  step,
  interactionMode
}) => {
  const {
    isSubmitting,
    disableControls,

    answerIsWrong,
    answerIsRight,

    onChallengeRetry,
    onChallengeAdvance,

    stepsCustomFooters,
    journeyAllowWrongAnswers,

    goToPrevStep,
    goToNextStep,

    onChallengeContinue
  } = useLevelContext()
  let { save_answer: saveAnswer = false } = activity.meta

  if (stepsCustomFooters[step.id])
    return (
      <LevelPlay.Footer id={id}>
        {step.hasIntro && (
          <DigitalProductJourneyLevelPlayChallengeFooterIntroButton />
        )}

        {stepsCustomFooters[step.id]}
      </LevelPlay.Footer>
    )
  if (step.isIntro)
    return (
      <LevelPlay.Footer id={id}>
        <Button
          variant="primary"
          className="grow"
          showTrailingIcon={false}
          leadingIcon={<PlayIcon size={20} variant="duotone" />}
          onClick={goToNextStep}
        >
          Avançar
        </Button>
      </LevelPlay.Footer>
    )
  if (step.isSlide)
    return (
      <LevelPlay.Footer id={id}>
        {step.hasIntro && (
          <DigitalProductJourneyLevelPlayChallengeFooterIntroButton />
        )}

        {!step.isFirstSlide && (
          <Button
            variant="ghost"
            size="md"
            showTrailingIcon={false}
            aria-label="Voltar"
            leadingIcon={<ArrowLeftDoubleIcon variant="duotone" size={20} />}
            onClick={goToPrevStep}
            className="shrink-0 !px-0 w-[var(--btn-h-md)]"
          />
        )}
        {step.isLastSlide ? (
          <Button
            variant="primary"
            className="grow"
            showTrailingIcon={false}
            loading={isSubmitting}
            disabled={isSubmitting}
            onClick={() =>
              onChallengeContinue({ uid: activity.uid, advance: true })
            }
          >
            {isSubmitting ? 'Carregando' : 'Continuar'}
          </Button>
        ) : (
          <Button
            variant="secondary"
            className="grow"
            trailingIcon={<ArrowRightDoubleIcon variant="duotone" size={20} />}
            onClick={goToNextStep}
          >
            Próximo
          </Button>
        )}
      </LevelPlay.Footer>
    )
  if (_.isObject(interactionMode) && interactionMode.kind == 'continue')
    return (
      <LevelPlay.Footer id={id}>
        {step.hasIntro && (
          <DigitalProductJourneyLevelPlayChallengeFooterIntroButton />
        )}
        <DigitalProductJourneyLevelPlayChallengeFooterRightAnswerAlert
          challenge={activity}
        />

        <Button
          variant="primary"
          className="grow mt-auto"
          showTrailingIcon={false}
          loading={isSubmitting}
          disabled={
            interactionMode?.waitValidation && disableControls && !answerIsRight
          }
          onClick={() =>
            onChallengeContinue({ uid: activity.uid, advance: true })
          }
        >
          {isSubmitting ? 'Carregando' : 'Continuar'}
        </Button>
      </LevelPlay.Footer>
    )
  return (
    <LevelPlay.Footer id={id}>
      <DigitalProductJourneyLevelPlayChallengeFooterWrongAnswerAlert />
      <DigitalProductJourneyLevelPlayChallengeFooterRightAnswerAlert
        challenge={activity}
      />

      {step.hasIntro && (
        <DigitalProductJourneyLevelPlayChallengeFooterIntroButton />
      )}

      {!answerIsWrong && !answerIsRight && (
        <Button
          type="submit"
          variant="progress"
          className="grow mt-auto"
          showTrailingIcon={false}
          loading={isSubmitting}
          disabled={disableControls}
        >
          {isSubmitting
            ? saveAnswer
              ? 'Salvando'
              : 'Verificando'
            : saveAnswer
              ? 'Responder'
              : 'Verificar'}
        </Button>
      )}

      {answerIsWrong && (
        <Button
          variant="danger"
          className="grow mt-auto"
          showTrailingIcon={false}
          onClick={() =>
            journeyAllowWrongAnswers
              ? onChallengeAdvance()
              : onChallengeRetry({ keepAnswer: interactionMode?.keepAnswer })
          }
        >
          Entendido!
        </Button>
      )}

      {answerIsRight && (
        <Button
          variant="success"
          className="grow mt-auto"
          showTrailingIcon={false}
          onClick={onChallengeAdvance}
        >
          Continuar
        </Button>
      )}
    </LevelPlay.Footer>
  )
}
